<template>
  <SoPageWithHeader title="DCA Files">
    <SoButton
      type="text"
      title="Back to warrants"
      prepend-icon="arrow-left"
      class="mb-4 px-0"
      data-testid="warrants-files-back-btn"
      :to="{
        name: RouteNames.AdminServiceWarrants,
        params: { serviceName: $route.params.serviceName },
      }"
    />

    <WarrantsFilesSummaryCard class="mb-4" />

    <SoTabs v-model="currentTab" divider data-testid="warrants-files-tabs">
      <SoTab title="Jobs">
        <div class="pt-4">
          <WarrantsFilesJobsTab />
        </div>
      </SoTab>
      <SoTab title="Accounts">
        <div class="pt-4">
          <WarrantsFilesAccountsTab />
        </div>
      </SoTab>
      <SoTab title="Processed">
        <div class="pt-4">
          <WarrantsFilesProcessedTab />
        </div>
      </SoTab>
    </SoTabs>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import WarrantsFilesJobsTab from "./components/WarrantsFilesJobsTab.vue"
  import WarrantsFilesAccountsTab from "./components/WarrantsFilesAccountsTab.vue"
  import WarrantsFilesProcessedTab from "./components/WarrantsFilesProcessedTab.vue"
  import WarrantsFilesSummaryCard from "./components/WarrantsFilesSummaryCard.vue"
  import { RouteNames } from "@/types/router"

  // Tab indices match the order the SoTab children are declared.
  export enum WarrantsFilesTab {
    Jobs = 0,
    Accounts = 1,
    Processed = 2,
  }

  // URL slug for each tab (index aligns with WarrantsFilesTab) so the active
  // tab is reflected in the `?tab=` query — deep-linkable and restored on
  // back nav.
  const TAB_SLUGS = ["jobs", "accounts", "processed"]

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoButton,
      SoTabs,
      SoTab,
      WarrantsFilesJobsTab,
      WarrantsFilesAccountsTab,
      WarrantsFilesProcessedTab,
      WarrantsFilesSummaryCard,
    },
    data() {
      return {
        RouteNames,
      }
    },
    computed: {
      // The active tab is driven by the `?tab=` query param.
      currentTab: {
        get(): WarrantsFilesTab {
          const index = TAB_SLUGS.indexOf(this.$route.query.tab as string)
          return index === -1 ? WarrantsFilesTab.Jobs : index
        },
        set(tab: WarrantsFilesTab) {
          // replace (not push) so switching tabs doesn't spam browser history.
          this.$router.replace({
            query: { ...this.$route.query, tab: TAB_SLUGS[tab] },
          })
        },
      },
    },
  })
</script>
